var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShieldCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4 2.943L9.65.13a1.693 1.693 0 00-1.297 0l-6.75 2.813c-.63.26-1.04.875-1.04 1.557 0 6.979 4.025 11.802 7.787 13.37.414.172.882.172 1.297 0 3.013-1.255 7.79-5.59 7.79-13.37 0-.682-.41-1.297-1.037-1.557zm-7.182 13.89a.576.576 0 01-.432 0C5.344 15.469 1.688 10.688 1.688 4.5c0-.229.137-.432.344-.52l6.75-2.813a.575.575 0 01.432 0l6.75 2.813c.211.088.348.291.345.52.003 6.188-3.653 10.969-7.091 12.333zm4.788-11.426a.425.425 0 00-.597-.004l-5.745 5.7-2.426-2.444a.425.425 0 00-.597-.004l-.3.3a.425.425 0 00-.003.597l3.02 3.045a.426.426 0 00.598.003l6.346-6.293a.426.426 0 00.003-.598l-.299-.302z",
    fill: "#fff"
  })));
}

export default __webpack_public_path__ + "./fonts/shield-check.534f5663432470cd0510d81c1953331b.svg";
export { SvgShieldCheck as ReactComponent };